import React from 'react';
import { Link } from 'react-router-dom';

export default class Footer extends React.Component {
  render() {
    return(
      <div className='four-oh-four'>
        <p>
          Hmm. There's nothing here. But how about a quote about words?
        </p>
        <h2>“I am so clever that sometimes I don't understand a single word of what I am saying.”</h2>
        <p>
          —Oscar Wilde
        </p>
        <div className='action'>
          <Link to='/' className='btn btn-dark'>That's It. Move Along</Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/four_oh_four.jsx